"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_HealingRhythm_OnTickEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
let Effect_HealingRhythm_OnTickEventHandlerScript = class Effect_HealingRhythm_OnTickEventHandlerScript {
    run(sequence, container, handler, event) {
        const amount = Math.round((handler.args.scriptArgs.attributePercent / 100) * container.getMaxAttributeScore(event.subject, handler.args.scriptArgs.attribute));
        container.selectLivingTargets(event.subject, Target_1.Target.AllAllies)
            .forEach(targetId => container.applyHealing({
            healerId: event.subject,
            targetId,
            amount,
            attributePercent: 0,
            onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest", "front"), "BlueVapor", false)),
            sequence,
        }));
    }
};
Effect_HealingRhythm_OnTickEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_HealingRhythm_OnTick")
], Effect_HealingRhythm_OnTickEventHandlerScript);
exports.Effect_HealingRhythm_OnTickEventHandlerScript = Effect_HealingRhythm_OnTickEventHandlerScript;
